import {
  SendUsAnEmailForm as EmailForm,
  SendUsAnEmailFormProps,
} from '@stripe-internal/conversations-ui';
import {FormContainer} from '../helpers/FormContainer';

export function SendUsAnEmailForm(props: SendUsAnEmailFormProps) {
  return (
    <FormContainer>
      <EmailForm {...props} />
    </FormContainer>
  );
}
